var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12925_41763)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.16406 3.33301H3.33073C2.8887 3.33301 2.46478 3.5086 2.15222 3.82116C1.83966 4.13372 1.66406 4.55765 1.66406 4.99967V16.6663C1.66406 17.1084 1.83966 17.5323 2.15222 17.8449C2.46478 18.1574 2.8887 18.333 3.33073 18.333H14.9974C15.4394 18.333 15.8633 18.1574 16.1759 17.8449C16.4885 17.5323 16.6641 17.1084 16.6641 16.6663V10.833",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4141 2.0832C15.7456 1.75168 16.1952 1.56543 16.6641 1.56543C17.1329 1.56543 17.5825 1.75168 17.9141 2.0832C18.2456 2.41472 18.4318 2.86436 18.4318 3.3332C18.4318 3.80204 18.2456 4.25168 17.9141 4.5832L9.9974 12.4999L6.66406 13.3332L7.4974 9.99986L15.4141 2.0832Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12925_41763"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditWhite);
export default __webpack_public_path__ + "static/media/edit_white.48eff35c4ca9fb2d10d9921e34b953c8.svg";
export { ForwardRef as ReactComponent };